// Quack, this is a duck :) https://github.com/erikras/ducks-modular-redux
import update from 'immutability-helper';

/**************************
 * Events bundle
 *************************/
// Actions
const STORE_EVENT = 'Server Sent Event saved in store';

/**
//
events: {
    rfu: [ { code: '', subject: '', message: '', payload: { id: '', name: '' } }, ... ],
    dashboard: [ ... ],
}
 **/

// Reducer
const DEFAULT_STATE = {
    abnormalities: [],
    dashboard: [],
    recoveryActions: [],
    rfu: [],
    run: [],
};
export default function reducer(state = DEFAULT_STATE, action = {}) {
    switch (action.type) {
        case STORE_EVENT:
            return update(state, {
                dashboard: { $push: [action.data] },
            });
        default:
            return state;
    }
}

// Selectors
export const getEvents = state => state.events;
export const getAbnormalitiesEvents = state => state.events.abnormalities;
export const getDashboardEvents = state => state.events.dashboard;
export const getRecoveryActionsEvents = state => state.events.recoveryActions;
export const getRFUEvents = state => state.events.rfu;
export const getRunEvents = state => state.events.run;

// Action Creators/Thunks
export function storeEvent(data) {
    return function(dispatch) {
        dispatch({ type: STORE_EVENT, data: data });
    };
}
